module.exports = __webpack_public_path__ + "img/icon-twitter-blue.821702cb.svg";